// extracted by mini-css-extract-plugin
export default {"page":"HistoryPage_page__LvqvH","sections-list":"HistoryPage_sections-list__mI52o"};